import React from "react"
import { Badge } from "antd"

const InpatientBadge = ({ show, children }) => {
    if (show)
        return <Badge.Ribbon text="Inpatient" color="cyan">{ children }</Badge.Ribbon>

    return children
}

export default InpatientBadge